// Copyright (c) Docugami, Inc. All rights reserved.**/

import { InstallSamplesView } from "components/first-arrival/SampleSetsView";
import { UserUploadView } from "components/first-arrival/UserUploadView";
import { useEffect, useState } from "react";
import { TelemetryPageView } from "telemetry/TelemetryEvents";
import { Telemetry } from "telemetry/TelemetryManager";

export enum FirstArrivalView {
    UserUpload = "UserUpload",
    SampleSets = "SampleSets"
}

export interface FirstArrivalViewProps extends FirstArrivalProps {
    changeView: (view: FirstArrivalView) => void;
}

interface FirstArrivalProps {
    onComplete: () => void;
}

export const FirstArrival = (props: FirstArrivalProps) => {
    const [view, setView] = useState(FirstArrivalView.UserUpload);

    useEffect(() => {
        Telemetry.trackPageView(`${TelemetryPageView.FirstArrival}/${view}`);
    }, [view]);

    switch (view) {
        case FirstArrivalView.UserUpload:
            return <UserUploadView {...props} changeView={setView} />;
        case FirstArrivalView.SampleSets:
            return <InstallSamplesView {...props} changeView={setView} />;
        default:
            return <UserUploadView  {...props} changeView={setView} />;
    }
}
